import React from "react";
import { Card, CardHeader, CardContent, Fade } from "@material-ui/core";
class ExampleReport extends React.Component {
    render() {
        return (
            <div>
                <Fade in={true} timeout={{ enter: 400, exit: 400 }}>
                    <Card>
                        <CardHeader title={`Example Report`} subheader={`Example Report`} />

                        <CardContent />
                    </Card>
                </Fade>
            </div>
        );
    }
}

export default ExampleReport;
